import { Divider, Grid, Paper, Stack, Typography } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

interface Props {
  icon: ReactElement;
  title: string;
  size?: any;
  action?: ReactNode;
  children: ReactNode;
}

/** Mesmo cartão do Show do desconto e do clube de vantagens. */
const SectionCard = ({ icon, title, size = 12, action, children }: Props) => (
  <Grid size={size}>
    <Paper elevation={2} sx={{ p: 3, height: '100%' }}>
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        {icon}
        <Typography variant="h6" fontWeight={600} sx={{ flexGrow: 1 }}>{title}</Typography>
        {action}
      </Stack>
      <Divider sx={{ mb: 2 }} />
      {children}
    </Paper>
  </Grid>
);

export default SectionCard;
